import React, { memo, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { DragDropContext } from 'react-beautiful-dnd';
import { v4 as uuid } from 'uuid';
import { change } from 'redux-form';
import { connect } from 'react-redux';
import DroppableDiscipline from './DroppableDiscipline';
import { TIMETABLE } from '../../../shared/utils/constants';
import DroppableGrid from './DroppableGrid';

const TimetableDisciplineDraggable = (props) => {
  const {
    cardsSubjects,
    onChangeCardSubjects,
    dispatch,
    meta,
    timetableGrid,
    setTimetableGrid,
  } = props;

  const copy = (
    source,
    sourceDestination,
    hourIdentifier,
    droppableSource,
    droppableDestination,
    draggableId
  ) => {
    const sourceItemClone = source.find(
      (item) => item.subject.id === Number(draggableId)
    );
    const index = sourceDestination.findIndex(
      (item) => item.shiftItem.startAt === hourIdentifier
    );
    const cloneSourceDestination = [...sourceDestination];
    cloneSourceDestination[index] = {
      ...sourceDestination[index],
      shiftItem: {
        ...sourceDestination[index].shiftItem,
        card: { ...sourceItemClone, uuid: uuid() },
      },
    };
    const indexSourceItemClone = source.findIndex(
      (item) => item.subject.id === sourceItemClone.subject.id
    );
    const updatedCardsSubjects = [...source];
    sourceItemClone.restStep -= 1;
    updatedCardsSubjects[indexSourceItemClone] = sourceItemClone;
    onChangeCardSubjects(updatedCardsSubjects);
    return Array.from(cloneSourceDestination);
  };

  const restStepCard = (grid) => {
    const updatedCard = [...cardsSubjects];
    updatedCard.map((card) => {
      Object.keys(grid).forEach((day) => {
        grid[day].forEach((item) => {
          if (
            item.shiftItem.card.subject &&
            item.shiftItem.card.subject.id === card.subject.id
          ) {
            return { ...card, restStep: card.restStep - 1 };
          }
          return card;
        });
      });
      return card;
    });
    onChangeCardSubjects(updatedCard);
  };

  const onDragEnd = (values) => {
    const { source, destination, draggableId } = values;

    if (destination) {
      const [weekIdentifier, hourIdentifier] =
        destination.droppableId.split('.');
      if (source.droppableId === TIMETABLE.DISCIPLINE) {
        const updatedTimetable = {
          ...timetableGrid,
          [weekIdentifier]: copy(
            cardsSubjects,
            timetableGrid[weekIdentifier],
            hourIdentifier,
            source,
            destination,
            draggableId
          ),
        };
        restStepCard(updatedTimetable);
        setTimetableGrid(updatedTimetable);
      }
    }
  };

  const onRemoveCard = (identifier, card) => {
    const [weekId, hourId] = identifier.split('.');
    const sourceItemClone = cardsSubjects.find(
      (item) => item.subject.id === card.subject.id
    );
    const indexSourceItemClone = cardsSubjects.findIndex(
      (item) => item.subject.id === sourceItemClone.subject.id
    );
    const updatedCardsSubjects = [...cardsSubjects];
    sourceItemClone.restStep += 1;
    updatedCardsSubjects[indexSourceItemClone] = sourceItemClone;
    const indexOrigin = timetableGrid[weekId].findIndex(
      (item) => item.shiftItem.startAt === hourId
    );
    const cloneSourceOrigin = [...timetableGrid[weekId]];
    cloneSourceOrigin[indexOrigin] = {
      ...timetableGrid[weekId][indexOrigin],
      shiftItem: {
        ...timetableGrid[weekId][indexOrigin].shiftItem,
        card: { uuid: uuid() },
      },
    };
    onChangeCardSubjects(updatedCardsSubjects);
    setTimetableGrid({ ...timetableGrid, [weekId]: cloneSourceOrigin });
  };

  const changeChangeCardContentTimetableGrid = () => {
    const updatedTimetable = { ...timetableGrid };
    const cards = [...cardsSubjects];
    let updatedItems = [];
    Object.keys(updatedTimetable).forEach((day) => {
      cards.forEach((card) => {
        updatedItems = updatedTimetable[day].map((item) => {
          if (
            item.shiftItem.card.subject &&
            item.shiftItem.card.subject.id === card.subject.id
          ) {
            return {
              ...item,
              shiftItem: {
                ...item.shiftItem,
                card: { ...card },
              },
            };
          }
          return item;
        });
        updatedTimetable[day] = updatedItems;
      });
    });
    setTimetableGrid(updatedTimetable);
  };

  useEffect(() => {
    dispatch(change('SchoolClassForm', 'timetable', timetableGrid));
  }, [timetableGrid]);

  useEffect(() => {
    changeChangeCardContentTimetableGrid();
  }, [cardsSubjects]);

  return (
    <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
      <div className="timetable-discipline-draggable">
        <DragDropContext onDragEnd={onDragEnd}>
          <DroppableDiscipline list={cardsSubjects} />
          <DroppableGrid
            timeTable={timetableGrid}
            onRemoveCard={onRemoveCard}
          />
        </DragDropContext>
      </div>
      {meta.touched && meta.error && (
        <span className="form__form-group-error">{meta.error}</span>
      )}
    </div>
  );
};

TimetableDisciplineDraggable.propTypes = {
  timetableGrid: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)).isRequired,
  cardsSubjects: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)).isRequired,
  onChangeCardSubjects: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
  setTimetableGrid: PropTypes.func.isRequired,
};

TimetableDisciplineDraggable.defaultProps = {
  meta: {
    touched: false,
    error: '',
  },
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(memo(TimetableDisciplineDraggable))
);
